import React from 'react';

const sections = [
  {
    title: '1. Общие положения',
    text: 'Настоящее Пользовательское соглашение регулирует отношения между FreeApp (далее — «Магазин») и пользователем, осуществляющим покупку цифровых товаров на сайте. Используя сайт, вы соглашаетесь с условиями данного соглашения.',
  },
  {
    title: '2. Предмет соглашения',
    text: 'Магазин предоставляет пользователю доступ к покупке цифровых ключей активации для компьютерных игр и подписок на игровые платформы. Товар считается доставленным в момент передачи ключа в личный кабинет покупателя.',
  },
  {
    title: '3. Регистрация и аккаунт',
    text: 'Для совершения покупок необходимо зарегистрироваться. Пользователь несёт ответственность за конфиденциальность своих данных для входа и за все действия, совершённые под его аккаунтом.',
  },
  {
    title: '4. Оплата',
    text: 'Оплата производится в российских рублях. Магазин использует защищённые платёжные системы. Цена товара фиксируется на момент оформления заказа.',
  },
  {
    title: '5. Возврат и обмен',
    text: 'Возврат или замена возможны в случае, если переданный ключ не работает. Активированные ключи возврату не подлежат. Для оформления возврата обратитесь в службу поддержки в течение 48 часов с момента покупки.',
  },
  {
    title: '6. Ответственность',
    text: 'Магазин не несёт ответственности за невозможность активации ключа по причинам, не зависящим от него: региональные ограничения аккаунта пользователя, изменения политики платформ, технические неполадки на стороне правообладателя.',
  },
  {
    title: '7. Изменение условий',
    text: 'Магазин вправе изменять условия соглашения в одностороннем порядке. Актуальная версия всегда доступна на данной странице. Продолжение использования сайта после внесения изменений означает согласие с новыми условиями.',
  },
];

const TermsPage = () => (
  <div className="min-h-screen overflow-x-hidden bg-background px-4 py-6 text-foreground sm:py-8">
    <div className="mx-auto max-w-3xl">

      <div className="mb-8">
        <h1 className="text-3xl font-semibold sm:text-5xl">Пользовательское соглашение</h1>
        <p className="mt-3 text-sm text-foreground/35">Последнее обновление: май 2025</p>
      </div>

      <div className="rounded-[28px] border border-foreground/10 bg-card divide-y divide-foreground/[0.07] shadow-[0_24px_70px_rgba(0,0,0,0.35)]">
        {sections.map(({ title, text }) => (
          <div key={title} className="px-6 py-5">
            <p className="mb-2 font-semibold text-foreground">{title}</p>
            <p className="text-sm leading-6 text-foreground/55">{text}</p>
          </div>
        ))}
      </div>

    </div>
  </div>
);

export default TermsPage;
